import {match} from 'ts-pattern';

import {always} from 'ramda';
import {isNilOrEmpty, isNotNilOrEmpty} from 'ramda-adjunct';

import {PhoneNumber} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {isPhoneNumberValid} from '@dms/shared';

import {Nullish} from 'shared/web';

import {DefaultSignatoriesFormData} from '../types/DefaultSignatoriesFormData';

export type DefaultSignatoryFieldErrors = {
  name?: string;
  email?: string;
  phoneNumber?: string;
};

/**
 * Validates default signatory values with the same rules the per-document
 * form schema applies (name and email required, phone required and valid).
 * Returns an errors map keyed by signatory role; empty object when valid.
 */
export const getDefaultSignatoriesErrors = (
  formData: DefaultSignatoriesFormData,
  signatoryPersons: string[]
) =>
  signatoryPersons.reduce((errors: Record<string, DefaultSignatoryFieldErrors>, person) => {
    const values = formData[person];

    const fieldErrors: DefaultSignatoryFieldErrors = {
      ...(isNilOrEmpty(values?.name) ? {name: i18n.t('general.validations.fieldIsRequired')} : {}),
      ...(isNilOrEmpty(values?.email)
        ? {email: i18n.t('general.validations.fieldIsRequired')}
        : {}),
      ...getPhoneNumberErrorEntry(values?.phoneNumber),
    };

    return isNotNilOrEmpty(fieldErrors) ? {...errors, [person]: fieldErrors} : errors;
  }, {});

const getPhoneNumberErrorEntry = (phoneNumber: PhoneNumber | Nullish) =>
  match(phoneNumber)
    .when(
      (phone) => isNilOrEmpty(phone?.number),
      always({phoneNumber: i18n.t('general.validations.fieldIsRequired')})
    )
    .when(
      (phone) => !isPhoneNumberValid(phone),
      always({phoneNumber: i18n.t('general.validations.invalidPhoneNumber')})
    )
    .otherwise(always({}));
